// import axios from 'axios'
// import ElementUI from "element-ui";
//
// const request = axios.create({
//     baseURL: 'http://localhost:9090',  // 注意！！ 这里是全局统一加上了 '/api' 前缀，也就是说所有接口都会加上'/api'前缀在，页面里面写接口的时候就不要加 '/api'了，否则会出现2个'/api'，类似 '/api/api/user'这样的报错，切记！！！
//     timeout: 50000
// })
//
// // request 拦截器
// // 可以自请求发送前对请求做一些处理
// // 比如统一加token，对请求参数统一加密
// request.interceptors.request.use(config => {
//     config.headers['Content-Type'] = 'application/json;charset=utf-8';
//     let user=localStorage.getItem("user")?JSON.parse(localStorage.getItem("user")):null
//     if (user&& user.token){
//         config.headers['token']=user.token;
//     }
//     // config.headers['token'] = user.token;  // 设置请求头
//     return config
// }, error => {
//     return Promise.reject(error)
// });
//
// // response 拦截器
// // 可以在接口响应后统一处理结果
// request.interceptors.response.use(
//     response => {
//         let res = response.data;
//         // 如果是返回的文件
//         if (response.config.responseType === 'blob') {
//             return res
//         }
//         // 兼容服务端返回的字符串数据
//         if (typeof res === 'string') {
//             res = res ? JSON.parse(res) : res
//         }
//         //当权限验证不通过的时候给出提示
//         if (res.code==='401'){
//             ElementUI.Message({
//                 message:res.msg,
//                 type:'error'
//             });
//             // 清除本地存储的用户信息
//             localStorage.removeItem("user");
//             // 跳转到登录页面
//             window.location.href = "/login";
//         }
//         return res;
//     },
//     error => {
//         console.log('err' + error) // for debug
//         return Promise.reject(error)
//     }
// )
//
//
// export default request
//
import axios from 'axios';
import { Notification, MessageBox, Message, Loading } from 'element-ui'
import store from '@/store'
import { getToken } from '@/utils/auth'
import errorCode from '@/utils/errorCode'
import { tansParams, blobValidate } from "@/utils/ruoyi"
import cache from '@/plugins/cache'
import { saveAs } from 'file-saver'


let downloadLoadingInstance
// 是否显示重新登录
export let isRelogin = { show: false }

/*axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8'*/
// 创建axios实例
const service = axios.create({
    baseURL: process.env.VUE_APP_BASE_API,
    // 超时
    timeout: 30000
})

// request拦截器
service.interceptors.request.use(config => {
    // 关键修复：对于FormData类型（文件上传）不设置Content-Type，由浏览器自动处理
    if (!(config.data instanceof FormData)) {
        config.headers['Content-Type'] = 'application/json;charset=utf-8';
    } else {
        // 对于FormData类型，移除可能存在的Content-Type设置，让浏览器自动添加
        delete config.headers['Content-Type'];
    }
    // 是否需要设置 token
    const isToken = (config.headers || {}).isToken === false
    // 是否需要防止数据重复提交
    const isRepeatSubmit = (config.headers || {}).repeatSubmit === false
    if (getToken() && !isToken) {
        config.headers['Authorization'] = 'Bearer ' + getToken() // 让每个请求携带自定义token 请根据实际情况自行修改
    }
    // get请求映射params参数
    if (config.method === 'get' && config.params) {
        let url = config.url + '?' + tansParams(config.params)
        url = url.slice(0, -1)
        config.params = {}
        config.url = url
    }
    // if (!isRepeatSubmit && (config.method === 'post' || config.method === 'put')) {
    //     const requestObj = {
    //         url: config.url,
    //         data: typeof config.data === 'object' ? JSON.stringify(config.data) : config.data,
    //         time: new Date().getTime()
    //     }
    //
    //     const requestSize = Object.keys(JSON.stringify(requestObj)).length // 请求数据大小
    //     const limitSize = 5 * 1024 * 1024 // 限制存放数据5M
    //     if (requestSize >= limitSize) {
    //         console.warn(`[${config.url}]: ` + '请求数据大小超出允许的5M限制，无法进行防重复提交验证。')
    //         return config
    //     }
    //     const sessionObj = cache.session.getJSON('sessionObj')
    //     if (sessionObj === undefined || sessionObj === null || sessionObj === '') {
    //         cache.session.setJSON('sessionObj', requestObj)
    //     } else {
    //         const s_url = sessionObj.url                  // 请求地址
    //         const s_data = sessionObj.data                // 请求数据
    //         const s_time = sessionObj.time                // 请求时间
    //         const interval = 1000                         // 间隔时间(ms)，小于此时间视为重复提交
    //         if (s_data === requestObj.data && requestObj.time - s_time < interval && s_url === requestObj.url) {
    //             const message = '数据正在处理，请勿重复提交'
    //             console.warn(`[${s_url}]: ` + message)
    //             return Promise.reject(new Error(message))
    //         } else {
    //             cache.session.setJSON('sessionObj', requestObj)
    //         }
    //     }
    // }
    return config
}, error => {
    // console.log(error)
    Promise.reject(error)
})

// 响应拦截器
service.interceptors.response.use(res => {
        // 未设置状态码则默认成功状态
        const code = res.data.code || 200
        // 获取错误信息
        const msg = errorCode[code] || res.data.msg || errorCode['default']
        // 二进制数据则直接返回
        if (res.request.responseType ===  'blob' || res.request.responseType ===  'arraybuffer') {
            return res
        }
        if (code === 401) {
            // 某些页面的”回显/探测”类请求不希望打断用户操作（比如编辑弹框打开后后台补拉角色）。
            // 这类请求可通过 headers.silentAuth=true 启用静默模式：不弹出全局重新登录弹窗。
            const silentAuth = !!(res && res.config && res.config.headers && res.config.headers.silentAuth)
            if (silentAuth) {
                return Promise.reject({
                    code: 401,
                    message: msg,
                    silentAuth: true,
                    config: res.config
                })
            }
             if (!isRelogin.show) {
                 isRelogin.show = true
                 MessageBox.confirm('登录状态已过期，您可以继续留在该页面，或者重新登录', '系统提示', { confirmButtonText: '重新登录', cancelButtonText: '取消', type: 'warning' }).then(() => {
                     isRelogin.show = false
                     store.dispatch('LogOut').then(() => {
                         location.href = '/index'
                     })
                 }).catch(() => {
                     isRelogin.show = false
                 })
             }
             // console.log(“-----返回code==>401” + JSON.stringify(res.request))
             return Promise.reject('无效的会话，或者会话已过期，请重新登录。')
        } else if (code === 400) {
            // 登录失败等业务错误，显示具体错误信息
            Message({ message: msg, type: 'error' })
            return Promise.reject(new Error(msg))
        } else if (code === 500) {
            Message({ message: msg, type: 'error' })
            return Promise.reject(new Error(msg))
        }
        else if (code === 450) {
            Message({ message: msg, type: 'error' })
            return Promise.reject(new Error(msg))
        }
        else if (code === 600) {
            Message({ message: msg, type: 'warning' });
            return res.data;
        }else if (code === 601) {
            Message({ message: msg, type: 'warning' })
            return Promise.reject('error')
        } else if (code === 301) {
            Message({ message: msg, type: 'warning' })
            return res.data
        } else if (code !== 200) {
            Notification.error({ title: msg })
            return Promise.reject('error')
        } else {
            return res.data
        }
    },
    error => {
        console.log('err' + error)
        let message = error.response && error.response.data && error.response.data.msg
            ? error.response.data.msg
            : error.message
        if (message == "Network Error") {
            message = "后端接口连接异常"
        } else if (message.includes("timeout")) {
            message = "系统接口请求超时"
        } else if (message.includes("Request failed with status code")) {
            message = "系统接口" + message.substr(message.length - 3) + "异常"
        }
        Message({ message: message, type: 'error', duration: 5 * 1000 })
        return Promise.reject(error)
    }
)

// 通用下载方法
export function download(url, params, filename, config) {
    downloadLoadingInstance = Loading.service({ text: "正在下载数据，请稍候", spinner: "el-icon-loading", background: "rgba(0, 0, 0, 0.7)", })
    return service.post(url, params, {
        transformRequest: [(params) => { return tansParams(params) }],
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        responseType: 'blob',
        ...config
    }).then(async (data) => {
        const isBlob = blobValidate(data)
        if (isBlob) {
            const blob = new Blob([data])
            saveAs(blob, filename)
        } else {
            const resText = await data.text()
            const rspObj = JSON.parse(resText)
            const errMsg = errorCode[rspObj.code] || rspObj.msg || errorCode['default']
            Message.error(errMsg)
        }
        downloadLoadingInstance.close()
    }).catch((r) => {
        console.error(r)
        Message.error('下载文件出现错误，请联系管理员！')
        downloadLoadingInstance.close()
    })
}

export default service